<template>
  <form>
    <b-row cols="1" cols-lg="2">
      <b-col>
        <SelectorForm
          selectLabel="Estado"
          :selectFormOptions="selectFormOptions"
          @handlerSelect="onChangeStatus"
          :selectedOption="status"
          :isValid="this.budgetDataValidation.status"
          :disabled="!this.$store.getters.hasAdminPermission"
        />
      </b-col>
      <b-col>
        <b-form-group
          label="Fecha Realización"
          :hidden="!this.$store.getters.hasAdminPermission"
        >
          <b-form-datepicker
            id="receivedDate"
            v-model="performanceDate"
            placeholder="Fecha Realización"
            @context="onChangePerformanceDate"
            :date-format-options="{
              day: 'numeric',
              month: 'numeric',
              year: 'numeric'
            }"
            start-weekday="1"
            :reset-button="true"
            label-reset-button="Borrar fecha seleccionada"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row cols="1" cols-lg="2">
      <b-col>
        <b-form-group
          label="Fecha Revisión"
          :hidden="!this.$store.getters.hasAdminPermission"
        >
          <b-form-datepicker
            id="revisedDate"
            v-model="revisedDate"
            placeholder="Fecha Revisión"
            @context="onChangeRevisedDate"
            :date-format-options="{
              day: 'numeric',
              month: 'numeric',
              year: 'numeric'
            }"
            start-weekday="1"
            :reset-button="true"
            label-reset-button="Borrar fecha seleccionada"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group
          label="Fecha Aprobación"
          :hidden="!this.$store.getters.hasAdminPermission"
        >
          <b-form-datepicker
            id="approvedDate"
            v-model="approvedDate"
            placeholder="Fecha Aprobación"
            @context="onChangeApprovedDate"
            :date-format-options="{
              day: 'numeric',
              month: 'numeric',
              year: 'numeric'
            }"
            start-weekday="1"
            :reset-button="true"
            label-reset-button="Borrar fecha seleccionada"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row cols="1" cols-lg="2">
      <b-col :hidden="!this.$store.getters.hasAdminPermission">
        <SimpleInput
          inputLabel="Importe"
          inputId="budgetPhaseAmount"
          inputType="text"
          inputPlaceholder="Importe"
          :inputValue="amount"
          @handlerText="onChangeAmount"
        />
      </b-col>
      <b-col :hidden="!this.$store.getters.hasAdminPermission">
        <SimpleInput
          inputLabel="Nº Pedido"
          inputId="budgetPhaseOrderNumber"
          inputType="text"
          inputPlaceholder="Nº Pedido"
          :inputValue="orderNumber"
          @handlerText="onChangeOrderNumber"
        />
      </b-col>
    </b-row>
    <b-row>
    </b-row>
  </form>
</template>

<script>
import SelectorForm from '@/components/atoms/Forms/SelectorForm/SelectorForm.vue';
import SimpleInput from '@/components/atoms/Forms/SimpleInput/SimpleInput.vue';
import { getStatusSelectorOptionsBudget } from '@/helpers/StatusHelper';

export default {
  name: 'FormBudgetContent',
  components: {
    SelectorForm,
    SimpleInput,
  },
  props: {
    budgetData: {
      type: Object,
      default: () => {},
    },
    budgetDataValidation: Object,
  },
  data() {
    return {
      selectFormOptions: getStatusSelectorOptionsBudget(this.$store.getters.isSupplier),
      status: this.budgetData.status,
      performanceDate: this.budgetData.performanceDate,
      revisedDate: this.budgetData.revisedDate,
      approvedDate: this.budgetData.approvedDate,
      amount: this.budgetData.amount,
      orderNumber: this.budgetData.orderNumber,
      comments: this.budgetData.comments,
    };
  },
  methods: {
    onChangeStatus(data) {
      this.$emit('onChangeStatus', data);
    },
    onChangePerformanceDate(data) {
      if (data.selectedDate !== null) {
        this.$emit('onChangePerformanceDate', data.activeYMD);
      } else {
        this.$emit('onChangePerformanceDate', null);
      }
    },
    onChangeRevisedDate(data) {
      if (data.selectedDate !== null) {
        this.$emit('onChangeRevisedDate', data.activeYMD);
      } else {
        this.$emit('onChangeRevisedDate', null);
      }
    },
    onChangeApprovedDate(data) {
      if (data.selectedDate !== null) {
        this.$emit('onChangeApprovedDate', data.activeYMD);
      } else {
        this.$emit('onChangeApprovedDate', null);
      }
    },
    onChangeAmount(data) {
      if (data.amount !== null) {
        this.$emit('onChangeAmount', data);
      }
    },
    onChangeOrderNumber(data) {
      if (data.orderNumber !== null) {
        this.$emit('onChangeOrderNumber', data);
      }
    },
    onChangeComments(data) {
      if (data.comments !== null) {
        this.$emit('onChangeComments', data);
      }
    },
  },
};
</script>
